import "./CoreLayout.scss";

import NavBar from "../ui-components/NavBar/NavBar";
import PropTypes from "prop-types";
import React from "react";

export class CoreLayout extends React.Component {
  static propTypes = {
    children: PropTypes.any,
  };

  render() {
    const { children } = this.props;
    return (
      <div className="core-layout--root">
        <NavBar />
        <div className="core-layout--overlay" />
        <div className="core-layout--components">{children}</div>
      </div>
    );
  }
}

export default CoreLayout;
